@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.promotional-section {
  flex: 1;
  background-color: var(--green-00331C);
  padding: @space-24;
  align-items: center;
  justify-content: center;
  border-radius: 0 8px 8px 0;
}

.promotional-content {
  align-items: flex-start;
  max-width: 380px;
}

.promotional-header {
  color: var(--white);
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin: 0;
}

.promotional-subtext {
  color: var(--white);
  font-size: 16px;
  line-height: 24px;
}

.carrier-logos {
  width: auto;
  height: 40px;
  padding: 0;
  margin-top: @space-8;
}

@media screen and (max-width: 768px) {
  .promotional-section {
    padding: @space-20;
  }

  .promotional-content {
    max-width: none;
    text-align: center;
    align-items: flex-start;
  }
}
